import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Tag } from '@chakra-ui/react';
import { Moment } from 'moment';
import { momentTimezone } from '../utils/dateUtils';
import { TState } from '../../redux/store';

const HourCheck = ({ hour, onCheck, selected }: any) => {
  const theme = useSelector((state: TState) => state.theme);

  const [currMinutes, setCurrMinutes] = useState(0);

  useEffect(() => {
    setCurrMinutes(Number(selected));
  }, [selected]);

  return (
    <>
      {['00', '15', '30', '45'].map((minutes) => (
        <Tag
          mr={1}
          backgroundColor={
            currMinutes === Number(minutes) ? theme.light : theme.normal
          }
          fontSize={theme.fontSize.xSmall}
          onClick={(e) => {
            e.stopPropagation();
            const min = Number(minutes);
            setCurrMinutes(min);
            onCheck?.((date: Moment) => {
              return momentTimezone(date)?.minutes(min || 0);
            });
          }}
        >{`${hour}h${minutes}`}</Tag>
      ))}
    </>
  );
};

export default HourCheck;
